<template>
  <div class="mobile-container">
    <div class="search">
      <input v-model="query" @keyup.enter="search" placeholder="CIQ ID or Ticker" />
      <button @click="search">Search</button>
    </div>

    <div v-if="loading" class="loader">Loading…</div>
    <div v-if="error" class="error">{{ error }}</div>

    <div v-if="hasResults" class="sections">
      <!-- Mobile: do not display company name / business description here to match Dashboard2 behavior -->

      <!-- Reuse the existing dashboard1 components for compact display (General shown in a compact card layout on mobile) -->
      <General ref="generalComp" :company-id="companyId" />
      <Financials ref="financialsComp" :company-id="companyId" />
      <Transactions ref="transactionsComp" :company-id="companyId" />
      <KeyDevelopments ref="keyDevComp" :company-id="companyId" />
    </div>
  </div>
</template>

<script>
import General from '@/components/dashboard1/General.vue';
import Financials from '@/components/dashboard1/Financials.vue';
import Transactions from '@/components/dashboard1/Transactions.vue';
import KeyDevelopments from '@/components/dashboard1/KeyDevelopments.vue';
import { _http } from '@/api/backend.js';
const jp = require('jsonpath');

export default {
  name: 'Dashboard1Mobile',
  components: { General, Financials, Transactions, KeyDevelopments },
  data: () => ({
    query: '',
    companyId: '',
    error: null,
    loading: false,
    general: { companyName: '', Ticker: '', 'Business Description': '' },
  }),
  computed: {
    hasResults(){ return !!this.companyId }
  },
  methods: {
    async search() {
      if (!this.query) return;
      this.loading = true; this.error = null;
      try {
        await this.fetchGeneral(this.query);
        // reuse same pattern as desktop: call render on child components if available
        this.$nextTick(async () => {
          try { if (this.$refs.generalComp && this.$refs.generalComp.render) await this.$refs.generalComp.render(this.companyId || this.query) } catch (e) { console.warn('general render error', e); }
          try { if (this.$refs.financialsComp && this.$refs.financialsComp.render) await this.$refs.financialsComp.render(this.companyId || this.query) } catch (e) { console.warn('financials render error', e); }
          try { if (this.$refs.transactionsComp && this.$refs.transactionsComp.render) await this.$refs.transactionsComp.render(this.companyId || this.query) } catch (e) { console.warn('transactions render error', e); }
          try { if (this.$refs.keyDevComp && this.$refs.keyDevComp.render) await this.$refs.keyDevComp.render(this.companyId || this.query) } catch (e) { console.warn('key developments render error', e); }
        });
      } catch (e) {
        this.error = (e && e.message) ? e.message : String(e);
      }
      this.loading = false;
    },

    async fetchGeneral(query) {
      const accessToken = localStorage.getItem('accessToken');
      let resp = await _http(accessToken).post('/gdsapi/rest/v3/clientservice.json', {
        inputRequests: [
          { function: 'GDSP', identifier: query, mnemonic: 'IQ_COMPANY_NAME' },
          { function: 'GDSP', identifier: query, mnemonic: 'IQ_COMPANY_TICKER' },
          { function: 'GDSP', identifier: query, mnemonic: 'IQ_BUSINESS_DESCRIPTION' },
          { function: 'GDSP', identifier: query, mnemonic: 'IQ_COMPANY_ID' },
        ],
      });
      const r = jp.query(resp.data, '$..Row[0]');
      this.general.companyName = r[0];
      this.general.Ticker = r[1];
      this.general['Business Description'] = r[2];
      this.companyId = r[3];
    },
  }
};
</script>

<style scoped>
.mobile-container { padding: 8px; font-size:13px }
.search { display:flex; gap:6px; margin-bottom:8px }
input { flex:1; padding:6px; border:1px solid #ccc; border-radius:4px; font-size:13px }
button{ padding:6px 10px; font-size:13px }
.loader{ color:#666 }
.error{ color:#b00 }
.card{ margin-bottom:6px; padding:8px; border-radius:6px; background:#fff; box-shadow:0 0 0 1px #eee }
.sub{ color:#444; font-size:12px; margin-top:4px }
</style>